/* ============================================================================
   DAILE custom — содержимое мобильной шторки навигации (сентябрь 2026).

   Делает две вещи и обе — дописывает, ничего не удаляя:
     1) ставит над пунктами меню мелкие подписи-указатели («что это за раздел»);
     2) добавляет ПОД существующими пунктами блок выбора по числу деталей —
        три плитки 1000 / 500 / 300, ведущие в три коллекции.

   Данные приходят из sections/cart-drawer.liquid в window.DAILE_NAV: там же
   Liquid решает, показывать ли плитки вообще (коллекции могут быть ещё не
   созданы — до миграции каталога на четыре набора их нет), и там же лежат
   переводы через daile-t. Здесь никаких зашитых текстов и никаких цен: цены
   разные на двадцати с лишним рынках, в меню им не место.

   Две особенности шторки Prestige, из-за которых код именно такой:
     • при открытии узел <header-sidebar> физически переносится в <body>
       (assets/theme.js, Modal.shouldAppendToBody), поэтому ищем его по id,
       а не внутри .header;
     • список пунктов с обработчиками собирается один раз в connectedCallback
       по селектору с [aria-controls]. Наши плитки — простые ссылки <a>, так
       что ничего не перехватываем и ничего не ломаем. Вставляем именно <li>:
       тогда блок попадает в стаггер-анимацию revealItems().
   ========================================================================= */
(function () {
  'use strict';

  var data = window.DAILE_NAV;
  if (!data) return;

  function init() {
    var list = document.querySelector('#sidebar-menu .header-sidebar__linklist');
    if (!list || list.hasAttribute('data-daile-nav-done')) return;
    list.setAttribute('data-daile-nav-done', '');

    addEyebrows(list);
    addSets(list);
    moveCreatorsDown(list);
  }

  /* --- «For creators» — вниз панели ---

     В общем списке этот пункт спорит с тремя разделами каталога: он не про то,
     что купить, а про сотрудничество. Переносим его из списка вниз панели, над
     подвалом со входом и валютой. Пункт остаётся тем же узлом из админки, так
     что название и перевод по-прежнему правятся в Навигации. */

  function moveCreatorsDown(list) {
    var link = list.querySelector('a[href$="/pages/for-creators"]');
    if (!link) return;
    var li = link.closest('li');
    var scroller = document.querySelector('#sidebar-menu .header-sidebar__scroller');
    if (!li || !scroller) return;           /* разметка изменилась — оставляем как есть */

    /* Кладём кнопку ВНУТРЬ прокручиваемой области, сразу после списка.
       Если положить её между областью и подвалом, как было сначала, то на
       невысоком экране список не помещается, последняя строка обрезается, и
       кнопка выглядит наехавшей на неё. Внутри области она в худшем случае
       просто уезжает под прокрутку. А прижатие к низу делает CSS через
       margin-top: auto — когда место есть, кнопка всё равно внизу. */
    var slot = document.createElement('div');
    slot.className = 'daile-nav-creators';
    slot.appendChild(link);                 /* переносим саму ссылку, без li */
    scroller.appendChild(slot);
    li.remove();
  }

  /* --- подписи-указатели над пунктами --- */

  function addEyebrows(list) {
    var map = data.eyebrows || {};
    list.querySelectorAll('.header-sidebar__linklist-button').forEach(function (btn) {
      var href = btn.getAttribute('href');
      if (!href) return;                       /* кнопка подменю — пропускаем */
      var text = matchByPath(map, href);
      if (!text) return;                       /* нет подписи — пункт остаётся как был */
      var eyebrow = document.createElement('span');
      eyebrow.className = 'daile-nav-eyebrow';
      eyebrow.setAttribute('aria-hidden', 'true');  /* дубль для голосового доступа не нужен */
      eyebrow.textContent = text;
      btn.parentNode.insertBefore(eyebrow, btn);
    });
  }

  /* Пункты меню владелец правит в админке, и ссылка может быть как
     относительной, так и абсолютной, и с префиксом локали (/de/..., /ar/...).
     Поэтому сверяем по концу пути, а не по строгому равенству. */
  function matchByPath(map, href) {
    var path;
    try { path = new URL(href, window.location.origin).pathname; }
    catch (e) { path = href; }
    for (var key in map) {
      if (path === key || path.slice(-key.length) === key) return map[key];
    }
    return null;
  }

  /* --- блок «по количеству деталей» ---

     Не три одинаковых квадратика, а три строки: у каждой слева прямоугольник,
     нарисованный в НАСТОЯЩЕМ масштабе и пропорции готовой картины, справа
     число деталей, название набора и размер. Разница между 300 и 1000 видна
     глазом раньше, чем прочитан текст, а строка со стрелкой понятнее читается
     как нажимаемая, чем плитка без неё.

     Размеры и названия приходят из тех же ключей daile-t, что и карточка
     товара, поэтому разойтись с ней не могут. */

  function addSets(list) {
    var sets = data.sets || [];
    if (!sets.length) return;                  /* коллекций ещё нет — блока тоже нет */

    var li = document.createElement('li');
    li.className = 'daile-nav-sets-item';

    var box = document.createElement('div');
    box.className = 'daile-nav-sets';

    var label = document.createElement('p');
    label.className = 'daile-nav-sets__label';
    label.id = 'daile-nav-sets-label';
    label.textContent = data.setsLabel || '';
    box.appendChild(label);

    var group = document.createElement('div');
    group.className = 'daile-nav-sets__rows';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-labelledby', 'daile-nav-sets-label');

    sets.forEach(function (s) {
      group.appendChild(buildRow(s));
    });

    box.appendChild(group);
    li.appendChild(box);
    list.appendChild(li);
  }

  function buildRow(s) {
    var a = document.createElement('a');
    a.className = 'daile-nav-set';
    a.href = s.url;

    /* Масштабный прямоугольник. Ширина и высота — реальные сантиметры готовой
       картины, поэтому 1000 деталей выходит широким и низким, а 300 — узким
       и высоким. Это не украшение, это самая полезная разница между наборами. */
    var scale = document.createElement('span');
    scale.className = 'daile-nav-set__scale';
    scale.setAttribute('aria-hidden', 'true');
    /* Окно миниатюры одинаковое у всех трёх строк и квадратное — размер задаёт
       CSS. Прежде оно повторяло пропорцию готового пазла, но на вертикальных
       снимках строка 1000 выглядела растянутой. Разницу размеров несёт подпись. */
    if (s.img) {
      var img = document.createElement('img');
      img.src = s.img;
      img.alt = '';
      /* Не lazy: миниатюры лежат в закрытой шторке, за пределами экрана, и
         браузер откладывал их до первого открытия — картинки не успевали
         появиться. Три файла по паре килобайт, грузим сразу и с низким
         приоритетом, чтобы не спорить с главным изображением страницы. */
      img.loading = 'eager';
      img.setAttribute('fetchpriority', 'low');
      img.decoding = 'async';
      scale.appendChild(img);
    } else {
      scale.appendChild(document.createElement('i'));  /* коллекция пустая — просто рамка */
    }

    var body = document.createElement('span');
    body.className = 'daile-nav-set__body';

    var top = document.createElement('span');
    top.className = 'daile-nav-set__top';
    var num = document.createElement('b');
    num.className = 'daile-nav-set__num';
    num.textContent = s.pieces;
    var word = document.createElement('span');
    word.className = 'daile-nav-set__word';
    word.textContent = data.piecesWord || '';
    top.appendChild(num);
    top.appendChild(word);

    var meta = document.createElement('span');
    meta.className = 'daile-nav-set__meta';
    meta.textContent = s.name + ' · ' + s.size;

    body.appendChild(top);
    body.appendChild(meta);

    /* Стрелка — единственное, что здесь нарисовано, а не набрано:
       она и подсказывает, что строка ведёт дальше. */
    var arrow = document.createElement('span');
    arrow.className = 'daile-nav-set__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.1">' +
                      '<path d="M3 8h10M9 4l4 4-4 4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    a.setAttribute('aria-label', s.pieces + ' ' + (data.piecesWord || '') + ' — ' + s.name + ', ' + s.size);
    a.appendChild(scale);
    a.appendChild(body);
    a.appendChild(arrow);
    return a;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
